export default "/images/8478b070643f36f853a05f93e0cd5607.avif";